function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPhonePeIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 122.88 122.88",
    alt: "PhonePe logo",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M75.56 1.66a61.42 61.42 0 1 0 45.66 73.9 61.42 61.42 0 0 0-45.66-73.9Z",
    style: {
      fill: "#5f259f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.32 45.41A4.54 4.54 0 0 0 84.86 41h-8.24L57.75 19.33a7 7 0 0 0-7.21-2.06L44 19.33a1.52 1.52 0 0 0-.69 2.4l20.61 19.56H32.7A1.63 1.63 0 0 0 31 43v3.43a4.54 4.54 0 0 0 4.46 4.46h4.81v16.48c0 12.35 6.52 19.56 17.5 19.56a23.66 23.66 0 0 0 9.61-1.72v11a5.42 5.42 0 0 0 5.49 5.49h4.8a2.22 2.22 0 0 0 2.06-2.06V50.56h7.87a1.63 1.63 0 0 0 1.72-1.72v-3.43Zm-22 29.51a16.38 16.38 0 0 1-6.87 1.37c-5.49 0-8.23-2.74-8.23-8.92V50.9h15.1v24Z",
    style: {
      fill: "#fff"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhonePeIcon);
export default __webpack_public_path__ + "static/media/phonePeIcon.d479a31bdc51915497b8a0ff228c337f.svg";
export { ForwardRef as ReactComponent };